import groupedRequestDetailsStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_CLOSE_CALLBACK', function setCloseCallback(closeCallback: Function) {
    groupedRequestDetailsStore.closeCallback = closeCallback;
});